import { render, staticRenderFns } from "./ca_Dashboard.vue?vue&type=template&id=ea1b5f48"
import script from "./ca_Dashboard.vue?vue&type=script&lang=js"
export * from "./ca_Dashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports